  
import { Container, Row, Col, Tabs, Tab, Form, Button, Alert } from "react-bootstrap";
import React, { useEffect, useMemo, useState, useContext, Fragment } from "react";
import { useRef } from "react"; /* FOR TREE COMPONENT */

import { Typeahead } from "react-bootstrap-typeahead";
import Typography from '@mui/material/Typography';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SouthIcon from '@mui/icons-material/South';
import NorthIcon from '@mui/icons-material/North';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import clsx from 'clsx';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem2 } from '@mui/x-tree-view/TreeItem2';
import { useTreeItem2, UseTreeItem2Parameters } from '@mui/x-tree-view/useTreeItem2';
import GlobalContext from "../GlobalContext";
import { useMyContext } from "../MyContext";


import SuperAppObject from "./superappobject/SuperAppObject";
import YesNoDialog from "../components/YesNoDialog";

import { withRouter, useParams } from "react-router";
//import '../pages/Home.css';
import '../index.css';

//Components
import TopMargin from "../components/TopMargin";
import RowMargin from "../components/RowMargin";

const CustomContent = React.forwardRef(function CustomContent(props, ref) {
  const {
    classes,
    className,
    label,
    nodeId,
    icon: iconProp,
    expansionIcon,
    displayIcon,
    handleDeleteTab,
    handleAddTab,
    handleReorderTabs,
    tabName,
    index
  } = props;
  //console.log(JSON.stringify(props));

  const {
    disabled,
    expanded,
    selected,
    focused,
    handleExpansion,
    handleSelection,
    preventSelection,
  } = useTreeItem2(nodeId);
  //console.log(JSON.stringify(useTreeItem(nodeId)));

  const icon = iconProp || expansionIcon || displayIcon;

  const handleMouseDown = (event) => {
    preventSelection(event);
  };

  const handleExpansionClick = (event) => {
    handleExpansion(event);
  };

  const handleSelectionClick = (event) => {
    handleSelection(event);
  };

const [showYesNoDialog, setShowYesNoDialog ] = useState(false);

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={clsx(className, classes.root, {
        [classes.expanded]: expanded,
        [classes.selected]: selected,
        [classes.focused]: focused,
        [classes.disabled]: disabled,
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
      <div onClick={handleExpansionClick} className={classes.iconContainer}>
        {icon}
      </div>
      <Typography
        onClick={handleSelectionClick}
        component="div"
        className={classes.label}
      >
        Kevin{label}
      </Typography>
      {true &&
         <div>Kevin
         <IconButton edge="end" aria-label="add" onClick={() => { handleAddTab(); }} >
         <AddIcon style={{color: "white"}}/>
         </IconButton>
       </div>
      }
      {props.showUpButton &&
         <IconButton sx={{ padding: 1 }} edge="end" aria-label="reorder up" onClick={() => { handleReorderTabs(index, "UP"); }} >
         <NorthIcon color="white"/>
         </IconButton>
      }
      {props.showDownButton &&
         <IconButton sx={{ padding: 1 }} edge="end" aria-label="reorder down" onClick={() => { handleReorderTabs(index, "DOWN"); }} >
         <SouthIcon color="white" />
         </IconButton>
      }
      {props.showDeleteButton &&
         <IconButton sx={{ padding: 1 }} edge="end" aria-label="delete" onClick={() => { setShowYesNoDialog("true") }} >
         <YesNoDialog open={showYesNoDialog} title="Delete this tab?" tabName={tabName} />
         <DeleteIcon color="white"/>
         </IconButton>
      }
    </div>
  );
});

const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
  return <TreeItem2 ContentProps={{...props}} ContentComponent={CustomContent} {...props} ref={ref} />;
});



function Noder({ ref, styles, data }) {
  return (
    <div ref={ref} style={styles.row}>
      <div style={styles.indent}>{data.name}</div>
    </div>
  );
}
function Options({ options }) {
    return (
		options.map(option => 
			    <option>                                   
			    {option}
			    </option>)
			   );
		
};
 
function FieldRow({ autoFocus, formLabel, name, value, type, required, placeholder, onChange, defaultValue, values }) {
  var opts = {};

  if (type === 'checkbox')
     opts["checked"] = value

  if (autoFocus)
     opts["autoFocus"] = true

  if (required)
     opts["required"] = true

  if (type === 'select')
     opts["as"] = "select";

  if (name === 'style')
      value = JSON.stringify(value);
/*
		    <Row>
		      </div>
		      <div class="colStyle">
		    </Row>
*/
  return (
		      <div class="colStyleLeft">
		      <Form.Label>{formLabel}</Form.Label>
		      <Form.Control
                        {...opts}
			value={value?value:defaultValue?defaultValue:""}
			type={type}
			name={name}
			placeholder={placeholder}
			onChange={onChange}
		      >
{ values && 
<>
			      <option></option>
			      <Options options={values} />
</>
}
		      </Form.Control>
		      <Form.Control.Feedback type="invalid">
			 Please provide your {formLabel} 
		      </Form.Control.Feedback>
		      </div>
  );
}


const tabConfig = [ 
{eventKey: "home", title: "Home"}, 
{eventKey: "connections", title: "Connections"},
{eventKey: "idea_machine", title: "Idea Machine"},
{eventKey: "partner_connections", title: "Partner Connections"},
{eventKey: "help", title: "Help"} ,
{eventKey: "contact", title: "Contact"},
{eventKey: "admin", title: "Admin"},
{eventKey: "accounts", title: "Accounts"},
{eventKey: "content", title: "Content"},
{eventKey: "doc_ai_deals", title: "Doc AI Deals"},
{eventKey: "a120_collaboration", title: "A120 Collaboration"},
{eventKey: "sales_competition", title: "Sales Competition"}]


const headingPrimary = {
    'font-size': '3rem',
    'text-transform': 'uppercase',
    'font-weight': '700',
    'display': 'inline-block',
    'background-image': 'linear-gradient(to right, #2998ff, #5643fa)',
    '-webkit-background-clip': 'text',
    'color': 'transparent',
    'letter-spacing': '2px'
};

const paragraph = {
    'color': '#555',
    'line-height': '1.5',
    'font-size': '18px'
};
const barStyle = {
    'border-top-left-radius': '20px !important',
    'border-top-right-radius': '20px !important'
}

const matchButton = {
    'width': '100%',
    'padding': '10px',
    'margin': '10px',
    'text-align': 'center',
    'background-color': '#5643fa',
    'border': 'none',
    'font-size': '24px'
}

const formColumnStyleNoBorder = {
   width: "400px",
};
const xxx = {
   width: "50%",
   'margin': '10px',
   //border: '2px solid black',
   borderRadius: '5px !important',
   overflow: 'hidden'
};
const seventy = {
   width: "70%",
   'margin': '10px',
   //border: '2px solid black',
   borderRadius: '5px !important',
   overflow: 'hidden'
};
const thirty = {
   minWidth: "275px",
   'margin': '10px',
   //border: '2px solid black',
   borderRadius: '5px !important',
   overflow: 'hidden'
};
const formColumnStyle = {
   width: "400px",
   'border': '2px solid black'
};
const formColumnStyleNoWidth = {
   width: "700px",
   'border': '2px solid black'
};

const cardStyle = {
   "background-color": "#e5f1ff",
   "border-radius": "20px",
   "padding": "10px",
   "margin": "30px"
};

const divStyle = {
   width: "100%",
  'font-size': '24px',
  'padding': "25px 50px"
};

const divStyleSmallFont = {
  'font-size': '14px',
  'line-height': '1', 
};
const buttonStyle = {
   width: "100%",
   padding: 10,
   margin: 10,
   textAlign: "center",
   'background-color': '#5643fa',
   'font-size': '24px'
};

const connect_text = {
  'font-size': '16px',
  'display': 'block',
  'align-items': 'center'
}
const rowStyle = {
  'font-size': '16px',
  'display': 'flex',
  'align-items': 'center'
}

const connectionsStyle = {
   width: "40%",
  'font-size': '16px',
  'display': 'flex',
  'align-items': 'center'
}

const flex50 = {
    flex: "50%",
    "max-width": "49%",
    "margin-bottom": "20px",
    "border-radius": "20px"
};
const flex100 = {
    flex: "100%",
    "max-width": "100%",
    "margin-bottom": "20px",
    "border-radius": "20px"
};

const classes = {
  root: {
    flexGrow: 1
  },
  row: {
    width: "100%",
  },
  paper: {
    width: "100%",
    padding: 10,
    margin: 10,
    textAlign: "center",
    'font-size': '24px'
  }
};
var yesNoOptions = ["No", "Yes"];
var paOptions = ["Ads", "Alphabet", "Assistant", "GCP", "Commerce", "Core", "Devices and Services", "Geo", "Global Affairs", "Global Business & Operations", "Health", "Learning & Education", "Marketing", "Payments", "Platforms & Ecosystems", "People Operations", "Research", "Search", "YouTube", "Other"];
var googleRoleOptions = ["CE", "CEM", "FSR", "FSM", "TAM", "SWE", "PM", "SCE", "EM", "SA", "CSM", "DE", "Director", "Executive", "Other"];
var helpOptions = ["Provide Feedback", "Report a Bug", "Add Community", "Add Interest", "Add Business Interest"];
// generage select dropdown option list dynamically
/*
function Options({ options }) {
    return (
        //options.map(option => 
         //          <option key={option.id} value={option.value}>                                   
          //          {option.value}
           //         </option>)
        options.map(option => 
                    <option>                                   
                    {option}
                    </option>)
                   );
}
*/
        
function ConfigEditor(props) {

const { currentTab } = useParams();
const { dynamicConfig } = props;
console.log("Edit = " + props.edit);
console.log("USER = " + props.user);
console.log("TABCONFIG = " + JSON.stringify(props.dynamicConfig));
const myContext = useMyContext();
const superAppStyle = useContext(GlobalContext)["superAppStyle"];

console.log(JSON.stringify(superAppStyle));

const [showTreeNode, setShowTreeNode ] = useState("");
const [currentUser, setCurrentUser] = useState(props.user); /* KAD added this March 29, 2022 because props.user sometimes comes in blank and screws up code in useEffect */
const [validated, setValidated] = useState(false);

const [formData, setFormData] = useState({
    data: {"User": props.user, id: props.user},
    status: "IDLE"
  });
const [formDataConfig, setFormDataConfig] = useState({
    data: dynamicConfig,
    status: "IDLE"
  });
/* MOVE TO NEW COMPONENT */
const [ tableName, adminSetTableName ] = useState("");
const [ addTable, setAddTable ] = useState(false);

const [tabs, setTabs] = useState({
    data: (dynamicConfig && dynamicConfig.tab_order?dynamicConfig.tab_order:[]),
    status: "IDLE"
  });
const [fields, setFields] = useState({
    data: (dynamicConfig && dynamicConfig.app_config && tableName && tableName in dynamicConfig.app_config?dynamicConfig.app_config[tableName].fields:[{"name":"1","display_name":"Kevin"}]),
    status: "IDLE"
  });
const [table, setTable] = useState({
    data: (dynamicConfig && dynamicConfig.app_config && tableName && tableName in dynamicConfig.app_config?dynamicConfig.app_config[tableName].table:[{"kevin":"1"}]),
    status: "IDLE"
  });
const [header, setHeader] = useState({
    data: (dynamicConfig && dynamicConfig.app_config && tableName && tableName in dynamicConfig.app_config?dynamicConfig.app_config[tableName]:{}),
    status: "IDLE"
  });
/* MOVE TO NEW COMPONENT */

function sendChatMessage(message)
{
const webhookURL = 'https://chat.googleapis.com/v1/spaces/AAAAkwqshsk/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=AqmkzeZCCx3pwyTqLe5xaF1QEFUXor27nbTYRrc2kJg%3D';

const data = JSON.stringify({
  'text': message,
});

fetch(webhookURL, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json; charset=UTF-8',
  },
  body: data,
}).then((response) => {
  //console.log(response);
});
}

function changeTabFontSize() {
  var cols = document.getElementsByClassName('nav-link');
  var fontSize = "18px";
  if (cols.length > 8) 
     fontSize = "14px";
  
  for( var i = 0; i < cols.length; i++) {
    //cols[i].style.backgroundColor = 'blue';
    cols[i].style.fontSize = fontSize;
  }
}

 const handleInputChange = e => {
    const target = e.currentTarget;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
console.log(name);
console.log(value);
console.log(formData.data);
    setFormData({
      data: { ...formData.data, [name]: value, "User": props.user },
      status: "IDLE"
    });
console.log(formData.data);
  };

/*
      return (
         <SuperAppObject depth={1} style={superAppStyle} config={config["accounts"]} user={props.user} userDeep={props.userDeep} collection_name="accounts" input_data={props.userDeep.Accounts} display_state="BASIC_TABLE" on_row_click={handleAccountDrillDown} />
      )
*/
  const noDrillDown = row => {
  }

  const handleAccountDrillDown = row => {
    console.log("handle row clicked - " + JSON.stringify(row));
    props.history.push(`/acccounts/${row["NAICS Code"]}`);
      return <SuperAppObject depth={1} style={superAppStyle} config={config["accounts"]} user={props.user} userDeep={props.userDeep} collection_name="accounts" input_data={props.userDeep.Accounts} display_state="BASIC_TABLE" />
  }

  const selectTable = row => {
    
    console.log("handle row clicked - " + JSON.stringify(row));
    adminSetTableName(row.name);
/*
    var fields = (row.name in dynamicConfig.app_config?dynamicConfig.app_config[row.name].fields:[]);
    setFields({
      data: {...fields},
      status: "IDLE"
    });
    var table = (row.name in dynamicConfig.app_config?dynamicConfig.app_config[row.name].table:[]);
    setTable({
      data: {...table},
      status: "IDLE"
    });
*/

    setFields({
      data: (row.name in dynamicConfig.app_config?{...dynamicConfig.app_config[row.name]}.fields:[]),
      status: "IDLE"
    });
    setTable({
      data: (row.name in dynamicConfig.app_config?{...dynamicConfig.app_config[row.name]}.table:[]),
      status: "IDLE"
    });

    setHeader({
      data: (row.name in dynamicConfig.app_config?dynamicConfig.app_config[row.name]:{}),
      status: "IDLE"
    });
  }

  const handleRowClicked = row => {
    
    console.log("handle row clicked - " + JSON.stringify(row));
    props.history.push(`/interests/${row.Field1}`);
  }

 const handleDeleteTab = async (tabName) => {
     console.log("in handleDeleteTab()");
     if (tabName in dynamicConfig.app_config)
        delete dynamicConfig.app_config[tabName];
     for (let x = 0;x< dynamicConfig.tab_order.length;x++)
     {
        let obj = dynamicConfig.tab_order[x]; 
        if (obj.name === tabName)
        {
console.log("IN HERE " + x);
           dynamicConfig.tab_order.splice(x, 1);
        }
     }
     const response = await fetch("/api/saveObject/config", {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(dynamicConfig)
     });
     const data = await response.json();
     if (data.success){
        props.history.push("/admin");
     } else {
        throw Error("Failed to save data")
     }
 }
 const handleReorderTabs = async (index, direction) => {
     console.log("in handleReorderTabs()");
     var srcIndex = index;;
     var destIndex = index;
     if (direction === 'UP') destIndex--;
     if (direction === 'DOWN') destIndex++;
     console.log(direction);
     console.log(srcIndex + "-" + destIndex);
     var deleted = dynamicConfig.tab_order.splice(srcIndex, 1);
     dynamicConfig.tab_order.splice(destIndex, 0, deleted[0]);

     const response = await fetch("/api/saveObject/config", {
        headers: { "Content-Type": "application/json" },
        method: "post",
        body: JSON.stringify(dynamicConfig)
     });
     const data = await response.json();
     if (data.success){
        props.history.push("/admin");
     } else {
        throw Error("Failed to save data")
     }
 }

const tableTemplate = { 
   "fields": [
    {
     "required": false,
     "input_type": "text",
     "name": "field11",
     "display_name": "Field_One"
    }
   ],
   "buttonName": "Save",
   "otherTableOptions": {
    "paginationPerPage": 20
   },
   "security": {
    "delete": "CreatedBy",
    "view": "AllUsers",
    "create": "AllUsers",
    "edit": "CreatedBy"
   },
   "name": "Test Table",
   "tableName": "test_table",
   "flags": "",
   "collection": "test_table",
   "exportFields": [
    "field1",
    "field3"
   ],
   "table": [
    {
     "sortable": true,
     "selector": "field1",
     "minWidth": "20%",
     "name": "Field1"
    },
    {
     "sortable": true,
     "selector": "field2",
     "name": "Field2",
     "minWidth": "25%"
    }
   ],
   "showLikes": false,
   "filterField": "field1",
   "style": {
    "font-size": "11px"
   }
}
 const handleSaveFields = async (event, subArray, form) => {
    var result = dynamicConfig;
    console.log("in handleSaveFields " + JSON.stringify(form.data) + "-" + subArray + "-" + tableName);
    event.preventDefault();
    result["app_config"][tableName][subArray] = result["app_config"][tableName][subArray].concat(form.data);
   
         const response = await fetch("/api/saveObject/config", {
           headers: { "Content-Type": "application/json" },
           method: "post",
           body: JSON.stringify(result)
         });
         const data = await response.json();
         if (data.success){
           setFormDataConfig({
             ...formDataConfig,
             status: "SUCCESS"
           });
           props.history.push(`/admin`);
        
           setTimeout(function () { setFormDataConfig({
             data: {},
             status: "IDLE" }) } , 3000)
           setValidated(false);
         } else {
           throw Error("Failed to save data")
         }
 }
 const handleSaveTable = async (event, form) => {
    var result = dynamicConfig;
    event.preventDefault();
    console.log("in handleSaveTable " + JSON.stringify(form.data));
    result["app_config"][tableName]["table"].concat(form.data);
         const response = await fetch("/api/saveObject/config", {
           headers: { "Content-Type": "application/json" },
           method: "post",
           body: JSON.stringify(result)
         });
         const data = await response.json();
         if (data.success){
           setFormDataConfig({
             ...formDataConfig,
             status: "SUCCESS"
           });
           props.history.push(`/admin`);
        
           setTimeout(function () { setFormDataConfig({
             data: {},
             status: "IDLE" }) } , 3000)
           setValidated(false);
         } else {
           throw Error("Failed to save data")
         }
 }
 const handleSaveModule = async (event) => {

    const form = event.currentTarget;
    event.preventDefault();
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      console.log(" IN HERE CONFIG");
    }
    else
    {
       setValidated(true);
       var result = dynamicConfig;
       header.data["security"] = {
                        "create": "AllUsers",
                        "edit": "CreatedBy",
                        "delete": "CreatedBy",
                        "view": "AllUsers",
                    };
       const tableName = formData.data.tableName;
       header.data["style"] = {};
       header.data["tableName"] = tableName;
       header.data["name"] = formData.data.name;

console.log(JSON.stringify(formData.data));
console.log("kevin " + JSON.stringify(tabs.data));
       result["tab_order"] = (tabs.data).concat({"name":tableName,"id": (tabs.data).length + ""});
console.log("kevin " + JSON.stringify(result["tab_order"]));
       result["app_config"][tableName] = header.data;
       if (fields.data.length > 0)
          result["app_config"][tableName]["fields"] = fields.data;
       if (table.data.length > 0)
          result["app_config"][tableName]["table"] = table.data;

       try {   
          setFormDataConfig({
            data: result,
            status: "SUBMITTED"
          });
          console.log(formDataConfig);
          console.log(" IN HERE CONFIG");
          if (formDataConfig.data === null)
          { 
              console.log(" IN HERE CONFIG 2");
             setFormDataConfig({
               ...formDataConfig,
               status: "VALIDATION_FAILURE"
             });
               setTimeout(function () { setFormDataConfig({
                 ...formDataConfig,
                 status: "IDLE" }) } , 3000)
          }
          else
          {
          console.log(" IN HERE CONFIG 3 :" + JSON.stringify(formDataConfig.data));
             //formDataConfig.data.app_config["new_table"] = tableTemplate;
             var bodyData = formDataConfig.data;
             const response = await fetch("/api/saveObject/config", {
               headers: { "Content-Type": "application/json" },
               method: "post",
               body: JSON.stringify(bodyData)
             });
             const data = await response.json();
             if (data.success){
               setFormDataConfig({
                 ...formDataConfig,
                 status: "SUCCESS"
               });
               props.history.push(`/admin`);
               setShowTreeNode("");
        
               setTimeout(function () { setFormDataConfig({
                 data: {},
                 status: "IDLE" }) } , 3000)
               setValidated(false);
             } else {
               throw Error("Failed to save tableName")
             }
          }
       } catch (e) {
          console.log(`Failed to save config: ${formDataConfig.data}`);
          setFormDataConfig({
             ...formDataConfig,
             status: "ERROR"
          });
       }
    }
}
 const handleSubmitConfig2 = async (event) => {

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      console.log(" IN HERE CONFIG");
    }
    else
    {
       setValidated(true);
       var result = dynamicConfig;
       //if (!(tableName in result["app_config"]))
       //result["app_config"] = {tableName:{}};
       //if ("style" in header.data)
          //header.data["style"] = JSON.parse(header.data["style"]);
       header.data["security"] = {
                        "create": "AllUsers",
                        "edit": "CreatedBy",
                        "delete": "CreatedBy",
                        "view": "AllUsers",
                    };
       header.data["style"] = {};
       result["tab_order"] = tabs.data;
       result["app_config"][tableName] = header.data;
       result["app_config"][tableName]["fields"] = fields.data;
       result["app_config"][tableName]["table"] = table.data;
       try {   
          setFormDataConfig({
            data: result,
            status: "SUBMITTED"
          });
          console.log(formDataConfig);
      console.log(" IN HERE CONFIG");
      if (formDataConfig.data === null)
      { 
      console.log(" IN HERE CONFIG 2");
         setFormDataConfig({
           ...formDataConfig,
           status: "VALIDATION_FAILURE"
         });
           setTimeout(function () { setFormDataConfig({
             ...formDataConfig,
             status: "IDLE" }) } , 3000)
      }
      else
      {
      console.log(" IN HERE CONFIG 3 :" + JSON.stringify(formDataConfig.data));
         //formDataConfig.data.app_config["new_table"] = tableTemplate;
         var bodyData = formDataConfig.data;
         const response = await fetch("/api/saveObject/config", {
           headers: { "Content-Type": "application/json" },
           method: "post",
           body: JSON.stringify(bodyData)
         });
         const data = await response.json();
         if (data.success){
           setFormDataConfig({
             ...formDataConfig,
             status: "SUCCESS"
           });
           //props.history.push(`/`);
        
           setTimeout(function () { setFormDataConfig({
             data: {},
             status: "IDLE" }) } , 3000)
           setValidated(false);
         } else {
           throw Error("Failed to save user")
         }
      }
    } catch (e) {
       console.log(`Failed to save config: ${formDataConfig.data}`);
          setFormDataConfig({
         ...formDataConfig,
         status: "ERROR"
       });
    }
    }
}
 const handleSubmitConfig = async (event) => {

    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(true);
      console.log(" IN HERE CONFIG");
    }
    else
    {
       setValidated(true);
       try {   
          setFormDataConfig({
            data: {...formDataConfig.data},
            status: "SUBMITTED"
          });
          console.log(formDataConfig);
      console.log(" IN HERE CONFIG");
      if (formDataConfig.data === null)
      {         
      console.log(" IN HERE CONFIG 2");
         setFormDataConfig({
           ...formDataConfig,
           status: "VALIDATION_FAILURE"
         });
           setTimeout(function () { setFormDataConfig({
             ...formDataConfig,
             status: "IDLE" }) } , 3000)
      }
      else
      {
      console.log(" IN HERE CONFIG 3");
         formDataConfig.data.app_config["new_table"] = tableTemplate;
         var bodyData = formDataConfig.data;
         const response = await fetch("/api/saveObject/config", {
           headers: { "Content-Type": "application/json" },
           method: "post",
           body: JSON.stringify(bodyData)
         });
         const data = await response.json();
         if (data.success){
           setFormDataConfig({
             ...formDataConfig,
             status: "SUCCESS"
           });
           //props.history.push(`/`);
        
           setTimeout(function () { setFormDataConfig({
             data: {},
             status: "IDLE" }) } , 3000)
           setValidated(false);
         } else {
           throw Error("Failed to save user")
         }
      }
    } catch (e) {
       console.log(`Failed to save config: ${formDataConfig.data}`);
          setFormDataConfig({
         ...formDataConfig,
         status: "ERROR"
       });
    }
    }
}

function getConfig()
{
    var configObj = {};
    try {
         configObj["layout"] = {"tableName": "layout", 
                    "name": "Layout",
                    "buttonName": "Save",
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "XS",
                         name: "xs",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "MD",
                         name: "md",
                         input_type: "text",
                         default: "",
                         required: false
                      },
                      {
                         placeholder: "",
                         display_name: "Table Name",
                         name: "table_name",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                    ],
                    "table": [
{selector: "table_name", name: "Table Name", sortable:true},
{selector: "xs", name: "XS", sortable:true},
{selector: "md", name: "MD", sortable:true}
                    ],
                    "filterField": "table_name",
                    "exportFields": ["table_name"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["users"] = {"tableName": "users", 
                    "name": "Users",
                    "collection": "users",
                    "buttonName": "Save",
                    "defaultSort": { selector: 1, asc: false },
                    "security": {
                        "create": "",
                        "edit": "",
                        "delete": "",
                        "view": "",
                    },
                    "flags": "",
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "User",
                         name: "user",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Roles",
                         name: "roles",
                         input_type: "text",
                         default: "",
                         required: true
                      }
                    ],
                    "table": [
               { selector: (row) => row.user, name: "User", sortable: true, minWidth: "45%" },
               { selector: (row) => row.roles, name: "Roles", sortable: true, minWidth: "45%" }
                    ],
                    "filterField": "user",
                    "exportFields": ["user"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["roles"] = {"tableName": "roles", 
                    "name": "Roles",
                    "buttonName": "Save",
                    "security": {
                        "create": "",
                        "edit": "",
                        "delete": "",
                        "view": "",
                    },
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "Role",
                         name: "Role",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Modules",
                         name: "Modules",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Role Description",
                         name: "Role Description",
                         input_type: "text",
                         default: "",
                         required: true
                      }
                    ],
                    "table": [
               { selector: (row) => row.Role, name: "Role", sortable: true, minWidth: "45%" },
               { selector: (row) => row.Modules, name: "Modules", sortable: true, minWidth: "45%" }
                    ],
                    "filterField": "Role",
                    "exportFields": ["Role"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["tabs"] = {"tableName": "tabs", 
                    "name": "Tabs",
                    "buttonName": "Save",
                    "security": {
                        "create": "AllUsers",
                        "edit": "AllUsers",
                        "delete": "AllUsers",
                        "view": "AllUsers",
                    },
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "Table Name",
                         name: "tableName",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Module Display Name",
                         name: "name",
                         input_type: "text",
                         default: "",
                         required: true
                      }
                    ],
                    "table": [{selector: "name", name: "Tab Name", sortable:true}
                    ],
                    "filterField": "name",
                    "exportFields": ["name"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["fields"] = {"tableName": "fields", 
                    "name": "Fields",
                    "buttonName": "Save",
                    "security": {
                        "create": "AllUsers",
                        "edit": "CreatedBy",
                        "delete": "CreatedBy",
                        "view": "AllUsers",
                    },
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "Name",
                         name: "name",
                         input_type: "text",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Display Name",
                         name: "display_name",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Placeholder",
                         name: "placeholder",
                         input_type: "text",
                         default: "",
                         flag: "autofocus",
                         required: false
                      },
                      {
                         placeholder: "",
                         display_name: "Input Type",
                         name: "input_type",
                         input_type: "dropdown",
                         values: ["text", "textarea", "dropdown", "checkbox", "list"],
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Values",
                         name: "values",
                         input_type: "text",
                         required: false
                      },
                      {
                         placeholder: "",
                         display_name: "Required",
                         name: "required",
                         input_type: "checkbox",
                         required: false
                      },
                      {
                         placeholder: "",
                         display_name: "Flags",
                         name: "flags",
                         input_type: "text",
                         flags: "stringToJSON",
                         required: false
                      },
                    ],
                    "table": [{selector: (row) => row.name, name: "Name", sortable:true}, 
                              {selector: (row) => row.display_name, name: "Display Name", sortable:true},
                              {selector:  (row) => row.input_type, name: "Input Type", sortable:true}
                    ],
                    "filterField": "name",
                    "exportFields": ["name", "display_name", "input_type", "values"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["table"] = {"tableName": "table", 
                    "name": "Table",
                    "buttonName": "Save",
                    "security": {
                        "create": "AllUsers",
                        "edit": "CreatedBy",
                        "delete": "CreatedBy",
                        "view": "AllUsers",
                    },
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "Name",
                         name: "selector",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Display Name",
                         name: "name",
                         input_type: "text",
                         default: "",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Sortable",
                         name: "sortable",
                         input_type: "checkbox",
                         required: false
                      }
                    ],
                    "table": [{selector: "selector", name: "Name", sortable:true}, 
                              {selector: "name", name: "Display Name", sortable:true},
                              {selector: "sortable", name: "Sortable", sortable:true,
                              cell: row => (row.sortable?"Yes":"No") }
                    ],
                    "filterField": "name",
                    "exportFields": ["selector", "name", "sortable"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["feedback"] = {"tableName": "feedback", 
                    "name": "Feedback",
                    "buttonName": "Save",
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "User",
                         name: "User",
                         input_type: "text",
                         default: "{USER}",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Request Type",
                         name: "RequestType",
                         input_type: "dropdown",
                         values: ["Provide Feedback", "Report a Bug", "Add Community", "Add Interest", "Add Business Interest"],
                         required: true
                      },
                      {
                         placeholder: "DataEntity",
                         display_name: "Data Entity",
                         name: "DataEntity",
                         input_type: "textarea",
                         required: true
                      },
                      {
                         placeholder: "Creation Date",
                         display_name: "Creation Date",
                         name: "CreationDate",
                         input_type: "display",
                         required: false
                      },
                      {
                         placeholder: "Update Date",
                         display_name: "Update Date",
                         name: "UpdateDate",
                         input_type: "display",
                         required: false
                      }
                    ],
                    "table": [{selector: "User", name: "User", sortable:true}, 
                              {selector: "RequestType", name: "Request Type", sortable:true},
                              {selector: "DataEntity", name: "Data Entity", sortable:true},
                              {selector: "CreationDate", name: "Creation Date", sortable:true, sortOrder:"desc",
                              cell: row => (row.CreationDate?row.CreationDate.substring(0,10):"Unknown") },
                              {selector: "UpdateDate", name: "Update Date", sortable:true,
                              cell: row => (row.UpdateDate?row.UpdateDate.substring(0,10):"Unknown") }
                    ],
                    "filterField": "DataEntity",
                    "exportFields": ["User", "RequestType", "DataEntity", "CreationDate"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
         configObj["users"] = {"tableName": "users", 
                    "name": "users",
                    "buttonName": "Save",
                    "fields": [
                      {
                         placeholder: "",
                         display_name: "User",
                         name: "User",
                         input_type: "text",
                         required: true
                      },
                      {
                         placeholder: "",
                         display_name: "Roles",
                         name: "Roles",
                         input_type: "text",
                         required: true
                      },
                    ],
                    "table": [{selector: "User", name: "User", sortable:true}, 
                              {selector: "Roles", name: "Roles", sortable:true}],
                    "filterField": "User",
                    "exportFields": ["User", "Roles", "CreationDate"],
                    "otherTableOptions": {"paginationPerPage":20}
                   }
    }
    catch(e)
    {
       console.log("Failed to configure: " + e);
       console.log(e.stack);
    } 
    return configObj;
}
/*
const matchesConfig = getConfig("matches");
const feedbackConfig = getConfig("feedback");
const commonInterestsConfig = getConfig("common_interests");
{ props.userDeep && props.userDeep.Roles && props.userDeep.Roles.toLowerCase().indexOf("admin") >= 0 && (
)}
*/

const config = getConfig();
changeTabFontSize();

 useEffect(() => {
    if (tableName && tableName.length === 0) return;
console.log("useEffects - " + tableName);
console.log(JSON.stringify(dynamicConfig));
      //data: (tableName in dynamicConfig.app_config && "fields" in dynamicConfig.app_config[tableName]?{...dynamicConfig.app_config[tableName]}.fields:[]),
    setFields({
      data: (tableName in dynamicConfig.app_config && "fields" in dynamicConfig.app_config[tableName]?dynamicConfig.app_config[tableName]["fields"]:[]),
      status: "IDLE"
    });
    setTable({
      data: (tableName in dynamicConfig.app_config && "table" in dynamicConfig.app_config[tableName]?{...dynamicConfig.app_config[tableName]}.table:[]),
      status: "IDLE"
    });

    setHeader({
      data: (tableName in dynamicConfig.app_config?dynamicConfig.app_config[tableName]:{}),
      status: "IDLE"
    });
 }, [tableName])
const headerConfig = { 
            "collection": "header",
            "name": "Header",
            "showLikes": false,
            "buttonName": "Save",
            "defaultSort": { selector: 5, asc: false },
            "security": {
               "create": "AllUsers",
               "edit": "AllUsers",
               "delete": "createdBy",
               "view": "AllUsers",
            },
            flags: "",
            "fields": [
               {
                  placeholder: "",
                  display_name: "Table Name",
                  name: "tableName",
                  input_type: "text",
                  default: "",
                  required: true
               },
               {
                  placeholder: "",
                  display_name: "Display Name",
                  name: "name",
                  input_type: "text",
                  default: "",
                  required: true
               },
               {
                  placeholder: "",
                  display_name: "Display Type",
                  name: "displayType",
                  input_type: "dropdown",
                  values: ['TABLE', 'BASIC_TABLE'],
                  default: "",
                  required: true
               },
               {
                  placeholder: "",
                  display_name: "Flags",
                  name: "flags",
                  input_type: "text",
                  default: "",
                  required: false
               },
               {
                  placeholder: "",
                  display_name: "Button Name",
                  name: "buttonName",
                  input_type: "text",
                  default: "Save",
                  required: false
               },
               {
                  placeholder: "",
                  display_name: "Show Likes",
                  name: "showLikes",
                  input_type: "checkbox",
                  default: "",
                  required: false
               }
          ]};
	  return (
	<React.StrictMode>
	    <Container fluid>
	{ true  && (
			<React.Fragment>
			  <RowMargin />
			  <RowMargin />
<div style={{display: "flex"}}>
 <h2 style={{ color: "white"}} >Admin</h2>
<TreeView
  style={{ color: "white"}} 
  itemId="100"
  aria-label="Admin Console"
  defaultCollapseIcon={<ExpandMoreIcon />}
  defaultExpandIcon={<ChevronRightIcon />}
  sx={{ height: 400, flexGrow: 1, maxWidth: 275, overflowY: 'auto' }}
>
  <CustomTreeItem style={{ color: "white"}} itemId="1" nodeId="1" label="Modules" showAddButton={true} handleAddTab={() => setShowTreeNode("Add New Table")} >
    { dynamicConfig.tab_order && dynamicConfig.tab_order.map((key, index) => {
       var opts = {};

       if (index > 0)
       {
          opts["showUpButton"] = true
       }
       if (index < dynamicConfig.tab_order.length - 1)
       {
          opts["showDownButton"] = true
       }
    return(
       <CustomTreeItem style={{ color: "white"}} index={index} itemId="3" nodeId="3" label={key.name} tabName={key.name} handleDeleteTab={handleDeleteTab} showDeleteButton={true} {...opts} handleReorderTabs={handleReorderTabs} onClick={() => adminSetTableName(key.name)} >
          <TreeItem2 style={{ color: "white"}} itemId="5" nodeId="5" label="Header" onClick={() => {adminSetTableName(key.name); setShowTreeNode("Header");}} />
          <TreeItem2 style={{ color: "white"}} itemId="6" nodeId="6" label="Fields" onClick={() => {console.log("Fields = " + key.name); adminSetTableName(""); adminSetTableName(key.name); setShowTreeNode("Fields");}} />
          <TreeItem2 style={{ color: "white"}} itemId="9" nodeId="9" label="Table Layout" onClick={() => {adminSetTableName(key.name); setShowTreeNode("Table Layout");}} />
      
       </CustomTreeItem>
    )
   })
   }
  </CustomTreeItem>
  <TreeItem2 style={{ color: "white"}} itemId="12" nodeId="12" label="Users" onClick={() => setShowTreeNode("Users")} />
  <TreeItem2 style={{ color: "white"}} itemId="13" nodeId="13" label="Roles" onClick={() => setShowTreeNode("Roles")} />
  <TreeItem2 style={{ color: "white"}} itemId="14" nodeId="14" label="Feedback" onClick={() => setShowTreeNode("Feedback")} />
</TreeView>
                { showTreeNode === "Add New Table" &&
                    <div>
                    <>
		    <Form noValidate validated={validated} onSubmit={handleSaveModule}>
                    <Row>
                    <FieldRow autoFocus="true" required="true" formLabel="Table Name" name="tableName" value={formData.data.tableName} type="text" placeholder="" onChange={handleInputChange} />
                    <FieldRow autoFocus="true" required="true" formLabel="Module Name" name="name" value={formData.data.name} type="text" placeholder="" onChange={handleInputChange} />
                    </Row>
		    <Button variant="primary" type="submit">
		      Save 
		    </Button>

                    </Form>
                    </>
                    </div>
                }
                { showTreeNode === "Header" && (
                    <div style={{width: "webkitFillAvailable", align: "right"}}>
                    <h2 style={{color: "white"}} >{tableName}</h2>
                    <div className="table-listing-page-wrapper">
                     <SuperAppObject depth={1} style={superAppStyle} title="Header" config={headerConfig} user={props.user} userDeep={props.userDeep} collection_name="header" display_state="CREATE_EDIT" input_data={[]} dontPersistData="true" pagination="false" submit={handleSubmitConfig2} />
                    </div>
                    </div>
                  )}
                  { showTreeNode === "Fields" &&
                     <div className="table-listing-page-wrapper">
                     <SuperAppObject depth={1} style={superAppStyle} title="Fields" config={config["fields"]} user={props.user} userDeep={props.userDeep} collection_name="fields" display_state="TABLE" input_data={fields.data} dontPersistData="true" pagination="false" submit={handleSaveFields} />
                     </div>
                  }
                  { showTreeNode === "Table Layout" &&
                     <div className="table-listing-page-wrapper">
                     <SuperAppObject depth={1} style={superAppStyle} title="Tables" config={config["table"]} user={props.user} userDeep={props.userDeep} collection_name="table" display_state="TABLE" input_data={table.data} dontPersistData="true" pagination="false" submit={handleSaveFields} />
                     </div>
                  }
                  { showTreeNode === 'Feedback' && 
                     <div className="table-listing-page-wrapper">
                     <SuperAppObject depth={1} style={superAppStyle} title="Feedback" config={config["feedback"]} user={props.user} userDeep={props.userDeep} collection_name="feedback" display_state="TABLE" />
                     </div>
                  }
                  { showTreeNode === 'Users' && 
                     <div className="table-listing-page-wrapper">
                      <SuperAppObject depth={1} style={superAppStyle} title="Users" config={config["users"]} user={props.user} userDeep={props.userDeep} collection_name="users" display_state="TABLE" />
                     </div>
                  }
                  { showTreeNode === 'Roles' && 
                     <div className="table-listing-page-wrapper">
                     <SuperAppObject depth={1} style={superAppStyle} title="Roles" config={config["roles"]} user={props.user} userDeep={props.userDeep} collection_name="roles" display_state="TABLE" />
                     </div>
                  }
</div>
			</React.Fragment>
        )}
	    </Container>
	</React.StrictMode>
	  );
	}
	export default withRouter(ConfigEditor);

